
import React, { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader, Table } from "reactstrap";
import DefaultOffCanvas from "../DefaultOffCanvas";
import styles from "./style.module.scss"
import cx from "classnames";
import moment from "moment";

const EasyposLogsOffCanvas = props => {
    const { btnColor = "primary", className, packageCostData } = props;
    const [isOpen, setOpen] = useState(false);
    const [easyposLogs, setEasyposLogs] = useState([]);
    const easyposLogsJson = packageCostData?.easyposLog || "";

    useEffect(() => {
        try {
            const logs = JSON.parse(easyposLogsJson);
            setEasyposLogs(logs)
        } catch (e) {
            setEasyposLogs([]);
        }
    }, [easyposLogsJson]);

    const toogleOffCanvas = (newState) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const openURL = (url) => {
        window.open(url, '_blank');
    }

    const getLogDetailsTableData = () => {
        return easyposLogs.map((r, index) => {
            const timeStamp = (r.created || 0) / 1000; //get timestamo on seconds
            const dateObject = moment.unix(timeStamp);

            return (
                <tr>
                    <td>{dateObject.format('DD-MM-YYYY h:mm A')}</td>
                    <td>{r.description}</td>
                    <td className={styles.linkColumns}>
                        {r.invoiceId && !r.creditNoteId && (
                            <Button color="primary" size="sm" type="button" onClick={() => openURL(`https://easyposcr.com/invoices/printInvoice/${r.invoiceId}/0/0`)}>
                                Ver Factura
                            </Button>
                        )}

                        {r.creditNoteId && r.creditNoteId !== -1 && (
                            <Button color="primary" size="small" type="button" onClick={() => openURL(`https://easyposcr.com/creditnotes/printCreditnote/${r.creditNoteId}/0`)}>
                                Ver Nota de Credito
                            </Button>
                        )}
                    </td>
                </tr>
            )
        });
    }

    return (
        <>
            <Button
                color={btnColor}
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            <DefaultOffCanvas
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Movimiento en Easypos
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Table className={styles.logTable}>
                            <thead>
                                <tr>
                                    <th className="col-3"> Fecha </th>
                                    <th className="col-6"> Description</th>
                                    <th className={cx(["col-3", styles.tablePriceColumn])}> Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getLogDetailsTableData()}
                            </tbody>
                        </Table>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas>
        </>
    );
}
export default EasyposLogsOffCanvas;
